import { UpdateBulkEmployeesSalary } from '../../pages';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { useFileUpload } from 'use-file-upload';
import { observer } from 'mobx-react';
import { EmployeeController } from '../../controllers';

const UpdateBulkEmployeesSalaryContainer = ({ closeModal, printUpdateEmployeeSalaryData }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();
	const selectClick = () => {
		selectFile({ accept: '.xlsx' });
	};

	const uploadClick = async () => {
		setLoading(true);
		let fileToSend;
		const formData = new FormData();
		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
		}
		formData.append('employees', fileToSend);
		const {
			status,
			errorMessage,
		} = await EmployeeController.updateBulkEmployeesSalary(formData);
		if (status === constant.Success) {
			setLoading(false);
			setUploaded(true);
		}else {
			MimaToastUtil.error({
				message: errorMessage,
			})
		}
	};


	return (
		<UpdateBulkEmployeesSalary
			closeModal={closeModal}
			printUpdateEmployeeSalaryData={printUpdateEmployeeSalaryData}
			uploaded={uploaded}
			uploadClick={uploadClick}
			file={file}
			selectClick={selectClick}
			loading={loading}
		/>
	);
};

export default observer(UpdateBulkEmployeesSalaryContainer);
